import React from 'react';
import ratios from 'Components/utils/ratios/ratios.utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Image } from 'Components/frameworks/image/Image';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
type ProductImageMapLineProps = {
  mapMobileDimensions?: {
    w: number;
    h: number;
  };
  mapTabletRatio?: MediaRatios;
  resort?: {
    name: string;
    mapUrl?: string;
  };
  title?: string;
};
export const ProductImageMapLine = ({
  mapMobileDimensions = {
    w: 600,
    h: 500,
  },
  mapTabletRatio = ratios.S,
  resort = {},
  title,
}: ProductImageMapLineProps) => {
  const { isTablet } = useResponsive();
  const { name: altMsg, mapUrl: imageUrl } = resort;

  if (!imageUrl) {
    return null;
  }

  const map = {
    altMsg,
    imageUrl,
  };
  const mapConf = isTablet
    ? {
        ratioKey: mapTabletRatio,
        transformation: 'resize',
      }
    : {
        dimensions: mapMobileDimensions,
      };
  return (
    <SiteContainer className="Line Line-ProductImageMap">
      <LineTitle className="mb-20">{title}</LineTitle>
      <Image {...map} {...mapConf} className="overflow-hidden rounded-12" />
    </SiteContainer>
  );
};
